export enum enumLclCardStyle {
  DEFAULT,
  LIGHT,
  DARK,
}
